import { isNotFound, notFound } from '@tanstack/react-router';
import { ApiError } from '@wundo/client/api.ts';

/**
 * Loads what a detail page needs before it renders, so a record that is not
 * there becomes the router's not-found page instead of a page that half-mounts.
 * Any other failure is swallowed on purpose: the page's own query hits the same
 * cache entry and shows its usual error.
 */
export async function loadOrNotFound(load: () => Promise<unknown>): Promise<void> {
  try {
    await load();
  } catch (error) {
    if (isNotFound(error)) throw error;
    if (error instanceof ApiError && error.type === 'not_found') throw notFound();
  }
}
